import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

export const GetPlannedSurveyByIDKey = 'PLANNED_SURVEY_BY_ID';

export const useGetPlannedSurveyById = (
  teamId: number,
  surveyId: number,
  isEnabled: boolean = true,
) => {
  const { getPlannedSurveyById } = useServicesContext();
  return useQuery({
    queryKey: [GetPlannedSurveyByIDKey, teamId, surveyId],
    queryFn: () => getPlannedSurveyById(teamId, surveyId),
    enabled: Boolean(teamId) && isEnabled,
  });
};
